import { render, staticRenderFns } from "./biddingFlow.vue?vue&type=template&id=31fcdad7&scoped=true"
import script from "./biddingFlow.vue?vue&type=script&lang=js"
export * from "./biddingFlow.vue?vue&type=script&lang=js"
import style0 from "./biddingFlow.vue?vue&type=style&index=0&id=31fcdad7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fcdad7",
  null
  
)

export default component.exports